import {PaymentTransactionStatus, ProductTier} from '@/enums';
import {palette} from '@/styles';

export const TOSS_CLIENT_KEY = process.env.REACT_APP_TOSS_CLIENT_KEY;
export const TOSS_ONETIME_CLIENT_KEY =
  process.env.REACT_APP_TOSS_ONETIME_CLIENT_KEY;

export const PAY_HISTORY_STATUS = {
  [PaymentTransactionStatus.APPROVED]: {
    label: '결제 완료',
    color: palette.green400,
  },
  [PaymentTransactionStatus.CANCELED]: {
    label: '환불 완료',
    color: palette.red400,
  },
  [PaymentTransactionStatus.PARTIAL_CANCELED]: {
    label: '부분 취소',
    color: palette.red400,
  },
};

export const ACTIVE_TIER = [ProductTier.Lite, ProductTier.Trial];

export const TRIAL_DURATION = 14;
export const PREBENEFIT_PLAN_ORDER_NAME = '사전 신청 혜택';

/**
 * 스마트상점 이용권 코드. 신규 지급은 쿠폰으로 대체됐다.
 * 이미 trialInfo 로 이용 중인 회원의 요금제 표시·오픈 사전신청자 판정 제외에만 사용한다.
 */
export const SMART_STORE_26_CODE = 'smart-store-2026';

export const COUPON_CODES = ['festa-2026-06', SMART_STORE_26_CODE];
